<template>
  <v-flex>
    <v-dialog v-if="this.modelProveedor" v-model="dialogFormularioProveedor" width="1600px" persistent>
      <proveedor-formulario @cerrarFormularioProveedor="dialogFormularioProveedor = false"
        :modelProveedor="this.modelProveedor" :accion="this.accion" />
    </v-dialog>

    <v-dialog v-model="dialogFormularioDatosFiscales" width="1200px">
      <proveedor-datos-fiscales-formulario @cerrarFormularioDatosFiscales="dialogFormularioDatosFiscales = false"
        :modelProveedor="this.modelProveedor" :accion="'editar'" />
    </v-dialog>

    <v-dialog v-model="dialogCalendarioTarifas" width="1600px">
      <proveedor-calendario-tarifas @cerrarCalendarioTarifas="dialogCalendarioTarifas = false"
        :modelProveedor="this.modelProveedor"/>
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacion = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar el proveedor?
            </v-label>
          </v-row>


          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarProveedor()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacion = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Proveedores</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-chip class="mr-4" :color="colorAccent2" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip> -->
        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearProveedor">
          <!-- <v-avatar left>
            <v-icon size="20" color="white">mdi-account-plus</v-icon>
          </v-avatar> -->
          <span v-bind:style="{ color: 'white' }">
            Nuevo Proveedor
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="3" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaNombre" autocomplete="off"
              label="Búsqueda por nombre" placeholder="Especifique parte del nombre o los apellidos"
              @keyup.enter="_getProveedores(true)" dense></v-text-field>
          </v-col>
          <v-col cols="3" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaLocalidad" autocomplete="off"
              label="Búsqueda por localidad" placeholder="Especifíque parte de la localidad, provincia o direccion..."
              @keyup.enter="_getProveedores(true)" dense></v-text-field>
          </v-col>
          <v-col cols="3" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaTelefono" autocomplete="off"
              label="Busqueda por teléfono" placeholder="Teléfono del proveedor" @keyup.enter="_getProveedores(true)"
              dense></v-text-field>
          </v-col>
          <v-col cols="3" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaEmail" autocomplete="off"
              label="Busqueda por email" placeholder="Email del proveedor" @keyup.enter="_getProveedores(true)"
              dense></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="proveedores" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table v-if="proveedores" 
              locale="es" 
              dense 
              :headers="headersLargo" 
              :items="proveedores"
              :server-items-length="totalProveedores" 
              :options.sync="options"
              class="elevation-1 alternating-rows bordered-table" 
              :footer-props="{
                'items-per-page-options': [20, 50, 100],
                'items-per-page-text': 'Proveedores por página',
              }" @update:options="handleUpdateOptions">




              <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="_editar(item)">
                      <v-list-item-title>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_openDatosFiscales(item)">
                      <v-list-item-title>Datos Fiscales</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_openGestionCalendarioTarifas(item)">
                      <v-list-item-title>Gestionar Tarifas por Calendario</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_delete(item)">
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>

                  </v-list>
                </v-menu>
              </template>

              <template v-slot:no-data>
                No hay datos disponibles
              </template>



            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ProveedorFormulario from "../components/formularios/ProveedorFormulario";
import ProveedorDatosFiscalesFormulario from "../components/formularios/ProveedorDatosFiscalesFormulario";


export default {
  components: {
    ProveedorFormulario, 
    ProveedorDatosFiscalesFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaTelefono: "",
    busquedaEmail: "",
    busquedaLocalidad: "",
    accion: "",

    dialogFormularioProveedor: false,
    modelProveedor: null,
    showConfirmacionEliminacion: false,

    dialogFormularioDatosFiscales: false,


    dialogCalendarioTarifas: false,


    options: {},
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'nombre',

    headersLargo: [
      {
        text: "NOMBRE",
        align: "left",
        sortable: false,
        value: "nombre",
      },
      {
        text: "ALIAS",
        align: "left",
        sortable: false,
        value: "nombre_alias",
      },
      {
        text: "CIF",
        align: "left",
        sortable: false,
        value: "cif",
      },
      {
        text: "CATEGORIA",
        align: "left",
        sortable: false,
        value: "categoriaProveedor.nombre",
      },
      {
        text: "CONTACTO",
        align: "left",
        sortable: false,
        value: "contacto",
      },
      { text: "TELÉFONO", align: "left", sortable: false, value: "telefono" },
      {
        text: "EMAIL",
        align: "left",
        sortable: false,
        value: "email",
      },
      
      {
        text: "UBICACION",
        align: "left",
        sortable: false,
        value: "punto.nombre",
      },
      { text: "", width: "10px", value: "actions", sortable: false, align: "center" },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("proveedores", ["proveedores", "proveedorSelec", "totalProveedores", "regimenes",
      "categoriasProveedor", "tiposHabitacion", "caracteristicasHabitacion"]),
  },

  watch: {},

  mounted() {
    this._getMaestrasProveedores(false);
    this._getProveedores(true);
  },

  methods: {
    ...mapActions("proveedores", ["getProveedores", "eliminarProveedor", "updateProveedor", "getMaestrasProveedores"]),
    ...mapMutations("proveedores", ["setProveedorSelec"]),

    _inicializarModelProveedor() {
      this.modelProveedor = {
        id: null,
        nombre: null,
        nombre_alias: null,
        cif: null,
        tipo: null,

        categoriaProveedor: null,
        punto: null,

        categoria_proveedor_id: null,
        punto_id: null,
        
        contacto: null,
        telefono: null,
        email: null,
        contacto: null,

        localizacion: null,
        direccion: null,
        codigo_postal: null,
        poblacion: null,
        provincia: null,
        pais: null,

        direccion_fiscal: null,
        codigo_postal_fiscal: null,
        poblacion_fiscal: null,
        provincia_fiscal: null,
        pais_fiscal: null,
        banco_iban: null,

        observatorios: null,

        ofrecen_cena: null,
        ofrecen_cena_terceros: null,
        mascotas: null,
        request_tipo: null,
        request_automatico: null,
      };
    },

    rowClass(item, index) {
      return index % 2 === 0 ? 'light-blue-row' : '';
    },

    handleUpdateOptions(newOptions) {
      // Solo actualizamos si realmente ha cambiado algo relevante
      if (newOptions.page !== this.currentPage || newOptions.itemsPerPage !== this.itemsPerPage) {
        this.currentPage = newOptions.page;
        this.itemsPerPage = newOptions.itemsPerPage;
        this._getProveedores(false);
      }
    },





    _imprimir() { },

    async _getProveedores(showload) {
      const params = {};

      params.page = this.currentPage;
      params.per_page = this.itemsPerPage;
      params.sort_by = this.sortBy;

      if (this.busquedaNombre != null && this.busquedaNombre != "") {
        params.nombre = this.busquedaNombre;
      }
      if (this.busquedaLocalidad != null && this.busquedaLocalidad != "") {
        params.localidad = this.busquedaLocalidad;
      }
      if (this.busquedaTelefono != null && this.busquedaTelefono != "") {
        params.telefono = this.busquedaTelefono;
      }
      if (this.busquedaEmail != null && this.busquedaEmail != "") {
        params.email = this.busquedaEmail;
      }
      await this.getProveedores([this.access_token, params, showload]);
      console.log(this.proveedores);

    },

    async _getMaestrasProveedores(showload) {
      await this.getMaestrasProveedores([this.access_token, showload]);
    },

    _delete(item) {
      this.setProveedorSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    _crearProveedor() {
      this._inicializarModelProveedor();
      this.accion = 'crear';
      this.dialogFormularioProveedor = true;
    },

    _editar(item) {
      this.setProveedorSelec(item);
      let temp = JSON.parse(JSON.stringify(this.proveedorSelec));
      this.modelProveedor = temp;
      this.accion = 'editar';
      this.dialogFormularioProveedor = true;
    },

    async _eliminarProveedor() {
      this.showConfirmacionEliminacion = false;
      if (this.proveedorSelec != null) {
        await this.eliminarProveedor([this.access_token, this.proveedorSelec.id]);
      }
    },

    _openGestionCalendarioTarifas(item) {
      this.setProveedorSelec(item);
      let temp = JSON.parse(JSON.stringify(this.proveedorSelec));
      this.modelProveedor = temp;
      this.$router.push({ name: 'ProveedoresReglasTarifas' });
    },

    _openDatosFiscales(item) {
      this.setProveedorSelec(item);
      let temp = JSON.parse(JSON.stringify(this.proveedorSelec));
      this.modelProveedor = temp;
      this.accion = 'editar';
      this.dialogFormularioDatosFiscales = true;
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}


.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

</style>
